import { Textbox, Popup, Button, Checkbox } from 'components/generic';
import { useContext, useEffect, useState } from 'react';
import styles from './Moneytech.module.scss';
import { directDebitForm } from 'config/config';
import OverviewContext from 'store/overview-context';
import { requestValidator } from 'actions/actions';

const Moneytech = props => {
	const [showtermsConditions, showTermsConditions] = useState(false);
	const [isDisabled, setisDisabled] = useState(true);
	const overviewContext = useContext(OverviewContext);

	const popupToggler = e => {
		props.onPopupToggle(e);
	};

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	const getMoneytechLang = key => {
		switch (key) {
			case 'Account Name': return getLang('ACCOUNT_NAME');
			case 'BSB Number': return getLang('BSB_NUMBER');
			case 'Account Number': return getLang('ACCOUNT_NUMBER');
			default: return key
		}
	}

	useEffect(() => {
		const termsAcceptance = overviewContext?.createObj?.acceptTerms;
		const isValid = requestValidator({ ...overviewContext?.createObj, validatorKey: 'directDebitForm' }) || !termsAcceptance;
		setisDisabled(isValid);
	}, [overviewContext?.createObj]);

	const termsCheck = (e, key) => {
		showTermsConditions(e);
		key && setData(true, 'acceptTerms');
	};

	const setData = (data, key) => {
		overviewContext?.setCreateObj(prevState => ({ ...prevState, [key]: data }));
	};

	const displayForm = directDebitForm?.map(el => (
		<Textbox
			key={el?.key}
			value={overviewContext?.createObj?.[el?.key]}
			infoContent={getMoneytechLang(el?.infoContent)}
			mandatory
			onChange={e => setData(e?.target?.value, el?.key)}
			placeholder={getMoneytechLang(el?.placeholder)}
			label={getMoneytechLang(el?.label)}
		/>
	));

	const templateArray = overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.templateContent;
	const templateHtml = templateArray?.length && templateArray?.find(template => template?.templateLanguage?.toUpperCase() === overviewContext?.langObj?.key);

	const content = !showtermsConditions ? (
		<>
			{displayForm}
			<Checkbox content={getLang('I_AGREE')} link={getLang('TERMS_CONDITIONS')} checked={overviewContext?.createObj.acceptTerms} onLink={() => termsCheck(true, null)} onClick={e => setData(e?.target?.checked, 'acceptTerms')} last />
			<Checkbox content={getLang('DOES_PAYTO')} checked={overviewContext?.createObj.enablePayTo} onClick={e => setData(e?.target?.checked, 'enablePayTo')} />
			<Button primary full label={getLang('PAY_NOW')} disabled={isDisabled} onSubmit={props.onMoneytechPaynow} />
		</>
	) : (
		<>
			<div dangerouslySetInnerHTML={{ __html: templateHtml?.templateContent }}></div>
			<Button primary full label={getLang('AGREE')} onSubmit={() => termsCheck(false, 'acceptTerms')} />
		</>
	);

	return (
		<>
			<Popup onClose={popupToggler} popupState={props.showPopup}>
				<div className={styles.container}>
					<h2>{getLang('DIRECT_DEBIT')}</h2>
					<div className={`${styles.container__content} scroll-bar`}>{content}</div>
				</div>
			</Popup>
		</>
	);
};

export default Moneytech;
